import { useState } from "react";
import { Card, Button, Col, Row } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PricingModal from "../../components/Modals/PricingModel";

const plans = [
  {
    name: "Base Plan",
    priceText: "₹2999 / year",
    usersText: "Up to 100 users · 3,000 SMS",
    primary: true,

    included: [
        "CRM & Lead Management",
      "Ticket Management (Internal + Customer)",
      "Customer & Sub-Customer Login",
      "Customer Ticket Creation",
      "Field Service Requests (FSR)",
      "Inventory & Stock Management",
      "Material Request & Issue Management",
      "Stock Expenditure / Usage Tracking",
      "Expense & Expenditure Management",
      "AMC (Annual Maintenance Contract) Management",
      "User & Role Management",
      "Attendance, Punch-in / Punch-out & Leave",
      "Employee & Technician Tracking",
      "Service Requests Management",
      "Advanced Reports & Analytics",
    ],
  },

  {
    name: "Premium (Custom Plan)",
    priceText: "Contact us for pricing",
    usersText: "Custom users · Custom SMS · Scalable",
    contactOnly: true,

    included: [
      "CRM & Lead Management",
      "Ticket Management (Internal + Customer)",
      "Customer & Sub-Customer Login",
      "Customer Ticket Creation",
      "Field Service Requests (FSR)",
      "Inventory & Stock Management",
      "Material Request & Issue Management",
      "Stock Expenditure / Usage Tracking",
      "Expense & Expenditure Management",
      "AMC (Annual Maintenance Contract) Management",
      "User & Role Management",
      "Attendance, Punch-in / Punch-out & Leave",
      "Employee & Technician Tracking",
      "Service Requests Management",
      "Advanced Reports & Analytics",
    ],
  },
];

const PricingPlans = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const navigate = useNavigate();

  const handleActionClick = (plan) => {
    if (plan.contactOnly) {
      window.location.href =
        "mailto:fieldsathi@gmail.com?subject=Premium Plan Inquiry";
    } else {
      setSelectedPlan(plan);
      setShowModal(true);
    }
  };

  return (
    <div className="container py-5 text-center">
      <h2 className="fw-bold text-primary">Simple & Transparent Pricing</h2>
      <p className="text-muted mt-2">
        Choose a plan that fits your business today — upgrade anytime as you grow
      </p>

      <Row className="justify-content-center mt-4">
        {plans.map((plan, index) => (
          <Col md={5} key={index} className="mb-4">
            <Card
              className={`h-100 shadow-sm border-0 rounded-4 ${
                plan.primary ? "border border-primary" : ""
              }`}
            >
              <div className="card-header bg-light text-center">
                <h5 className=" mb-1">{plan.name}</h5>
                <p className="fs-6  mb-0">{plan.priceText}</p>
                <p className="fs-6 text-muted mb-0">{plan.usersText}</p>
              </div>

              <Card.Body className="text-start">
                <h6 className="fw-semibold mb-2">Included Features</h6>
                <ul className="list-unstyled small mb-3">
                  {plan.included.map((feature, idx) => (
                    <li key={idx} className="mb-1 d-flex align-items-start">
                      <FaCheck className="text-success me-2 mt-1" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                {plan.excluded && (
                  <>
                    <h6 className="fw-semibold text-danger mb-2">
                      Not Included
                    </h6>
                    <ul className="list-unstyled small text-muted">
                      {plan.excluded.map((feature, idx) => (
                        <li key={idx} className="mb-1 d-flex align-items-start">
                          <FaTimes className="text-danger me-2 mt-1" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </Card.Body>

              <Card.Footer className="bg-light border-0">
                <Button
                  variant={plan.contactOnly ? "outline-primary" : "primary"}
                  className="w-100"
                  onClick={() => handleActionClick(plan)}
                >
                  {plan.contactOnly ? "Contact Sales" : "Get Started"}
                </Button>
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>

      {selectedPlan && (
        <PricingModal
          show={showModal}
          onHide={() => setShowModal(false)}
          selectedPlan={selectedPlan}
        />
      )}
    </div>
  );
};

export default PricingPlans;
